export const SLEEP_EXPERT_CARDS = [
  {
    key: 'kim-jaeha',
    imageSrc: '/landing/sleep/lp-5078-expert-1.png',
    name: '김재하 전문의',
    title: '정신건강의학과/숨수면의원 대표원장',
    badge: '수면/숙면',
    prefix: '',
    highlight: '수면과 심신안정',
    suffix: '에 어려움을 겪고 있는 많은 사람들을 대상으로 최적의 솔루션을 제공할 수 있도록 도움을 줍니다.',
  },
  {
    key: 'yang-yongjun',
    imageSrc: '/landing/sleep/lp-5078-expert-2.png',
    name: '양용준 전문의',
    title: '정신건강의학과/오늘정신건강의학과 원장',
    badge: '스트레스 완화',
    prefix: '',
    highlight: '스트레스완화',
    suffix:
      ' 사운드 중재법을 누구보다 잘 알고 있으며, 스트레스로 어려움을 겪고 있는 많은 사람들을 대상으로 최적의 솔루션을 제공할 수 있도록 합니다.',
  },
  {
    key: 'yu-seungtaek',
    imageSrc: '/landing/sleep/lp-5078-expert-3.png',
    name: '유승택 전문의',
    title: '정신건강의학과/오늘정신건강의학과 원장',
    badge: '1분 명상',
    prefix: '',
    highlight: '인지능력 향상 및 집중력 향상',
    suffix:
      '에 효과적인 사운드 중재법을 누구보다 잘 알고 있으며, 집중력 관리에 어려움을 겪고 있는 사람들을 대상으로 최적의 솔루션을 제공할 수 있도록 합니다.',
  },
  {
    key: 'kim-jongse',
    imageSrc: '/landing/sleep/lp-5078-expert-4.png',
    name: '김종세 교수',
    title: '이비인후과/을지대학교 교수',
    badge: '집중력 향상',
    prefix: '청각자극을 통한 ',
    highlight: '인지능력 향상 및 집중력 향상',
    suffix: '에 효과적인 사운드 중재법으로, 집중력 관리에 최적의 솔루션을 제공할 수 있도록 합니다.',
  },
  {
    key: 'kim-dongwoo',
    imageSrc: '/landing/sleep/lp-5078-expert-5.png',
    name: '김동우 교수',
    title: '정신건강의학과/서울성모병원 정신건강의학과조교수',
    badge: '집중력 향상',
    prefix: '',
    highlight: '효과적인 집중력 사운드',
    suffix:
      ' 중재법을 누구보다 잘 알고 있으며, 현재 기억력 장애 및 치매, 인지기능 저하, 노인정신질환 등을 진료 및 연구하고 있습니다.',
  },
];
